<template>
  <div>
    <b-loading :is-full-page="true" :active="!initialized"></b-loading>
    <section v-if="initialized" class="section is-main-section">
      <CardComponent>
        <div>
          <span class="title">Manage Admins</span>
          <b-button
            type="is-primary"
            class="is-pulled-right"
            size="is-medium"
            @click="addAdmin"
            >Add Admin</b-button
          >
          <b-input
            v-if="entries.length > 0"
            v-model="search"
            class="has-margin-top-30"
            icon="magnify"
            :expanded="true"
            placeholder="Search by name or email"
          />
          <b-table
            class="has-margin-top-15"
            :data="filteredEntries"
            :narrowed="true"
            :hoverable="true"
            :mobile-cards="true"
          >
            <template slot-scope="props">
              <b-table-column
                label="Name"
                field="firstname"
                :sortable="true"
                width="200"
              >
                {{ props.row.firstname | capitalize }}
                {{ props.row.surname | capitalize }}
              </b-table-column>
              <b-table-column label="Email" field="email" :sortable="true">
                {{ props.row.email }}
              </b-table-column>
              <b-table-column label="" class="has-text-right">
                <b-button type="is-primary" @click="editEvents(props.row)">
                  Edit Events
                </b-button>
                <b-button
                  type="is-dark"
                  class="has-margin-left-10"
                  @click="deleteAdmin(props.row)"
                >
                  Delete
                </b-button>
              </b-table-column>
            </template>
          </b-table>
        </div>
      </CardComponent>
    </section>
    <b-modal :active.sync="showEventsModal">
      <div class="card">
        <div class="card-content">
          <p class="title">{{ entry.firstname }} {{ entry.surname }}</p>

          <span class="title is-4">Events:</span>
          <div v-for="event in entry.events" :key="event._id" class="columns">
            <div class="column is-6" style="padding: 10px 12px">
              {{ event.eventname }}
            </div>
            <div class="column is-3" style="padding: 10px">
              <a href="" @click.prevent="removeEvent(event)">
                <b-icon icon="close" />
              </a>
            </div>
          </div>
          <b-field>
            <b-select v-model="selectedEvent">
              <option v-for="event in events" :key="event._id" :value="event">
                {{ event.eventname }}
              </option>
            </b-select>
            <p class="control">
              <b-button
                class="button is-primary"
                @click="addEvent(selectedEvent)"
                >Add</b-button
              >
            </p>
          </b-field>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Filters from '@/mixins/filters'
import CardComponent from '@/components/CardComponent'
import UserApi from '@/api/user'
import EventApi from '@/api/event'

export default {
  name: 'ManageAdmins',
  components: {
    CardComponent
  },
  mixins: [Filters],
  data() {
    return {
      events: [],
      entries: [],
      search: '',
      showEventsModal: false,
      initialized: false,
      entry: {},
      selectedEvent: {}
    }
  },
  computed: {
    filteredEntries() {
      if (this.search !== '') {
        const search = this.search.toLowerCase()
        return this.entries.filter(
          entry =>
            entry.firstname.toLowerCase().includes(search) ||
            entry.surname.toLowerCase().includes(search) ||
            entry.email.toLowerCase().includes(search)
        )
      }
      return this.entries
    }
  },
  async created() {
    this.entries = await UserApi.getAdmins()
    this.events = await EventApi.getAll()
    this.initialized = true
  },
  methods: {
    async removeEvent(event) {
      this.entry.events = this.entry.events.filter(
        item => item._id !== event._id
      )
      await UserApi.updateEvents(
        this.entry._id,
        this.entry.events.map(item => item._id)
      )
      this.$buefy.toast.open({
        message: 'User events updated successfully.',
        position: 'is-top',
        type: 'is-success'
      })
    },
    async addEvent(event) {
      const found = this.entry.events.find(item => item._id === event._id)
      if (!found) {
        this.entry.events.push({ _id: event._id, eventname: event.eventname })
        await UserApi.updateEvents(
          this.entry._id,
          this.entry.events.map(item => item._id)
        )
        this.$buefy.toast.open({
          message: 'User events updated successfully.',
          position: 'is-top',
          type: 'is-success'
        })
      }
    },
    editEvents(entry) {
      this.entry = entry
      this.showEventsModal = true
    },
    deleteAdmin(entry) {
      this.$buefy.dialog.confirm({
        message:
          'Are you sure you want to delete this user from list of admins?',
        onConfirm: async () => {
          await UserApi.updateRole(entry._id, 'user')
          this.entries = this.entries.filter(item => item._id !== entry._id)
          this.$buefy.toast.open({
            message: 'User deleted from list of admins.',
            position: 'is-top',
            type: 'is-success'
          })
        }
      })
    },
    addAdmin() {
      this.$buefy.dialog.prompt({
        message: `Enter the user's email address`,
        inputAttrs: {
          type: 'email',
          placeholder: 'name@domain.com'
        },
        trapFocus: true,
        onConfirm: async value => {
          const user = await UserApi.getByEmail(value)
          if (!user) {
            this.$buefy.toast.open({
              message: 'User not found!',
              position: 'is-top',
              type: 'is-danger'
            })
            return
          }
          await UserApi.updateRole(user._id, 'admin')
          this.entries = await UserApi.getAdmins()
          this.$buefy.toast.open({
            message: 'User added successfully1',
            position: 'is-top',
            type: 'is-success'
          })
        }
      })
    }
  }
}
</script>
